import PropTypes from "prop-types";

import { CustomSelect } from "./custom-select";

const COUNTRIES = [
  {
    name: "Afghanistan",
    dial_code: "93",
    emoji: "🇦🇫",
    iso_code: "AF",
  },
  {
    name: "Aland Islands",
    dial_code: "358",
    emoji: "🇦🇽",
    iso_code: "AX",
  },
  {
    name: "Albania",
    dial_code: "355",
    emoji: "🇦🇱",
    iso_code: "AL",
  },
  {
    name: "Algeria",
    dial_code: "213",
    emoji: "🇩🇿",
    iso_code: "DZ",
  },
  {
    name: "AmericanSamoa",
    dial_code: "1684",
    emoji: "🇦🇸",
    iso_code: "AS",
  },
  {
    name: "Andorra",
    dial_code: "376",
    emoji: "🇦🇩",
    iso_code: "AD",
  },
  {
    name: "Angola",
    dial_code: "244",
    emoji: "🇦🇴",
    iso_code: "AO",
  },
  {
    name: "Anguilla",
    dial_code: "1264",
    emoji: "🇦🇮",
    iso_code: "AI",
  },
  {
    name: "Antarctica",
    dial_code: "672",
    emoji: "🇦🇶",
    iso_code: "AQ",
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "1268",
    emoji: "🇦🇬",
    iso_code: "AG",
  },
  {
    name: "Argentina",
    dial_code: "54",
    emoji: "🇦🇷",
    iso_code: "AR",
  },
  {
    name: "Armenia",
    dial_code: "374",
    emoji: "🇦🇲",
    iso_code: "AM",
  },
  {
    name: "Aruba",
    dial_code: "297",
    emoji: "🇦🇼",
    iso_code: "AW",
  },
  {
    name: "Australia",
    dial_code: "61",
    emoji: "🇦🇺",
    iso_code: "AU",
  },
  {
    name: "Austria",
    dial_code: "43",
    emoji: "🇦🇹",
    iso_code: "AT",
  },
  {
    name: "Azerbaijan",
    dial_code: "994",
    emoji: "🇦🇿",
    iso_code: "AZ",
  },
  {
    name: "Bahamas",
    dial_code: "1242",
    emoji: "🇧🇸",
    iso_code: "BS",
  },
  {
    name: "Bahrain",
    dial_code: "973",
    emoji: "🇧🇭",
    iso_code: "BH",
  },
  {
    name: "Bangladesh",
    dial_code: "880",
    emoji: "🇧🇩",
    iso_code: "BD",
  },
  {
    name: "Barbados",
    dial_code: "1246",
    emoji: "🇧🇧",
    iso_code: "BB",
  },
  {
    name: "Belarus",
    dial_code: "375",
    emoji: "🇧🇾",
    iso_code: "BY",
  },
  {
    name: "Belgium",
    dial_code: "32",
    emoji: "🇧🇪",
    iso_code: "BE",
  },
  {
    name: "Belize",
    dial_code: "501",
    emoji: "🇧🇿",
    iso_code: "BZ",
  },
  {
    name: "Benin",
    dial_code: "229",
    emoji: "🇧🇯",
    iso_code: "BJ",
  },
  {
    name: "Bermuda",
    dial_code: "1441",
    emoji: "🇧🇲",
    iso_code: "BM",
  },
  {
    name: "Bhutan",
    dial_code: "975",
    emoji: "🇧🇹",
    iso_code: "BT",
  },
  {
    name: "Bolivia, Plurinational State of",
    dial_code: "591",
    emoji: "🇧🇴",
    iso_code: "BO",
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "387",
    emoji: "🇧🇦",
    iso_code: "BA",
  },
  {
    name: "Botswana",
    dial_code: "267",
    emoji: "🇧🇼",
    iso_code: "BW",
  },
  {
    name: "Brazil",
    dial_code: "55",
    emoji: "🇧🇷",
    iso_code: "BR",
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "246",
    emoji: "🇮🇴",
    iso_code: "IO",
  },
  {
    name: "Brunei Darussalam",
    dial_code: "673",
    emoji: "🇧🇳",
    iso_code: "BN",
  },
  {
    name: "Bulgaria",
    dial_code: "359",
    emoji: "🇧🇬",
    iso_code: "BG",
  },
  {
    name: "Burkina Faso",
    dial_code: "226",
    emoji: "🇧🇫",
    iso_code: "BF",
  },
  {
    name: "Burundi",
    dial_code: "257",
    emoji: "🇧🇮",
    iso_code: "BI",
  },
  {
    name: "Cambodia",
    dial_code: "855",
    emoji: "🇰🇭",
    iso_code: "KH",
  },
  {
    name: "Cameroon",
    dial_code: "237",
    emoji: "🇨🇲",
    iso_code: "CM",
  },
  {
    name: "Canada",
    dial_code: "1",
    emoji: "🇨🇦",
    iso_code: "CA",
  },
  {
    name: "Cape Verde",
    dial_code: "238",
    emoji: "🇨🇻",
    iso_code: "CV",
  },
  {
    name: "Cayman Islands",
    dial_code: "345",
    emoji: "🇰🇾",
    iso_code: "KY",
  },
  {
    name: "Central African Republic",
    dial_code: "236",
    emoji: "🇨🇫",
    iso_code: "CF",
  },
  {
    name: "Chad",
    dial_code: "235",
    emoji: "🇹🇩",
    iso_code: "TD",
  },
  {
    name: "Chile",
    dial_code: "56",
    emoji: "🇨🇱",
    iso_code: "CL",
  },
  {
    name: "China",
    dial_code: "86",
    emoji: "🇨🇳",
    iso_code: "CN",
  },
  {
    name: "Christmas Island",
    dial_code: "61",
    emoji: "🇨🇽",
    iso_code: "CX",
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "61",
    emoji: "🇨🇨",
    iso_code: "CC",
  },
  {
    name: "Colombia",
    dial_code: "57",
    emoji: "🇨🇴",
    iso_code: "CO",
  },
  {
    name: "Comoros",
    dial_code: "269",
    emoji: "🇰🇲",
    iso_code: "KM",
  },
  {
    name: "Congo",
    dial_code: "242",
    emoji: "🇨🇬",
    iso_code: "CG",
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    dial_code: "243",
    emoji: "🇨🇩",
    iso_code: "CD",
  },
  {
    name: "Cook Islands",
    dial_code: "682",
    emoji: "🇨🇰",
    iso_code: "CK",
  },
  {
    name: "Costa Rica",
    dial_code: "506",
    emoji: "🇨🇷",
    iso_code: "CR",
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "225",
    emoji: "🇨🇮",
    iso_code: "CI",
  },
  {
    name: "Croatia",
    dial_code: "385",
    emoji: "🇭🇷",
    iso_code: "HR",
  },
  {
    name: "Cuba",
    dial_code: "53",
    emoji: "🇨🇺",
    iso_code: "CU",
  },
  {
    name: "Cyprus",
    dial_code: "357",
    emoji: "🇨🇾",
    iso_code: "CY",
  },
  {
    name: "Czech Republic",
    dial_code: "420",
    emoji: "🇨🇿",
    iso_code: "CZ",
  },
  {
    name: "Denmark",
    dial_code: "45",
    emoji: "🇩🇰",
    iso_code: "DK",
  },
  {
    name: "Djibouti",
    dial_code: "253",
    emoji: "🇩🇯",
    iso_code: "DJ",
  },
  {
    name: "Dominica",
    dial_code: "1767",
    emoji: "🇩🇲",
    iso_code: "DM",
  },
  {
    name: "Dominican Republic",
    dial_code: "1849",
    emoji: "🇩🇴",
    iso_code: "DO",
  },
  {
    name: "Ecuador",
    dial_code: "593",
    emoji: "🇪🇨",
    iso_code: "EC",
  },
  {
    name: "Egypt",
    dial_code: "20",
    emoji: "🇪🇬",
    iso_code: "EG",
  },
  {
    name: "El Salvador",
    dial_code: "503",
    emoji: "🇸🇻",
    iso_code: "SV",
  },
  {
    name: "Equatorial Guinea",
    dial_code: "240",
    emoji: "🇬🇶",
    iso_code: "GQ",
  },
  {
    name: "Eritrea",
    dial_code: "291",
    emoji: "🇪🇷",
    iso_code: "ER",
  },
  {
    name: "Estonia",
    dial_code: "372",
    emoji: "🇪🇪",
    iso_code: "EE",
  },
  {
    name: "Ethiopia",
    dial_code: "251",
    emoji: "🇪🇹",
    iso_code: "ET",
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "500",
    emoji: "🇫🇰",
    iso_code: "FK",
  },
  {
    name: "Faroe Islands",
    dial_code: "298",
    emoji: "🇫🇴",
    iso_code: "FO",
  },
  {
    name: "Fiji",
    dial_code: "679",
    emoji: "🇫🇯",
    iso_code: "FJ",
  },
  {
    name: "Finland",
    dial_code: "358",
    emoji: "🇫🇮",
    iso_code: "FI",
  },
  {
    name: "France",
    dial_code: "33",
    emoji: "🇫🇷",
    iso_code: "FR",
  },
  {
    name: "French Guiana",
    dial_code: "594",
    emoji: "🇬🇫",
    iso_code: "GF",
  },
  {
    name: "French Polynesia",
    dial_code: "689",
    emoji: "🇵🇫",
    iso_code: "PF",
  },
  {
    name: "Gabon",
    dial_code: "241",
    emoji: "🇬🇦",
    iso_code: "GA",
  },
  {
    name: "Gambia",
    dial_code: "220",
    emoji: "🇬🇲",
    iso_code: "GM",
  },
  {
    name: "Georgia",
    dial_code: "995",
    emoji: "🇬🇪",
    iso_code: "GE",
  },
  {
    name: "Germany",
    dial_code: "49",
    emoji: "🇩🇪",
    iso_code: "DE",
  },
  {
    name: "Ghana",
    dial_code: "233",
    emoji: "🇬🇭",
    iso_code: "GH",
  },
  {
    name: "Gibraltar",
    dial_code: "350",
    emoji: "🇬🇮",
    iso_code: "GI",
  },
  {
    name: "Greece",
    dial_code: "30",
    emoji: "🇬🇷",
    iso_code: "GR",
  },
  {
    name: "Greenland",
    dial_code: "299",
    emoji: "🇬🇱",
    iso_code: "GL",
  },
  {
    name: "Grenada",
    dial_code: "1473",
    emoji: "🇬🇩",
    iso_code: "GD",
  },
  {
    name: "Guadeloupe",
    dial_code: "590",
    emoji: "🇬🇵",
    iso_code: "GP",
  },
  {
    name: "Guam",
    dial_code: "1671",
    emoji: "🇬🇺",
    iso_code: "GU",
  },
  {
    name: "Guatemala",
    dial_code: "502",
    emoji: "🇬🇹",
    iso_code: "GT",
  },
  {
    name: "Guernsey",
    dial_code: "44",
    emoji: "🇬🇬",
    iso_code: "GG",
  },
  {
    name: "Guinea",
    dial_code: "224",
    emoji: "🇬🇳",
    iso_code: "GN",
  },
  {
    name: "Guinea-Bissau",
    dial_code: "245",
    emoji: "🇬🇼",
    iso_code: "GW",
  },
  {
    name: "Guyana",
    dial_code: "595",
    emoji: "🇬🇾",
    iso_code: "GY",
  },
  {
    name: "Haiti",
    dial_code: "509",
    emoji: "🇭🇹",
    iso_code: "HT",
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "379",
    emoji: "🇻🇦",
    iso_code: "VA",
  },
  {
    name: "Honduras",
    dial_code: "504",
    emoji: "🇭🇳",
    iso_code: "HN",
  },
  {
    name: "Hong Kong",
    dial_code: "852",
    emoji: "🇭🇰",
    iso_code: "HK",
  },
  {
    name: "Hungary",
    dial_code: "36",
    emoji: "🇭🇺",
    iso_code: "HU",
  },
  {
    name: "Iceland",
    dial_code: "354",
    emoji: "🇮🇸",
    iso_code: "IS",
  },
  {
    name: "India",
    dial_code: "91",
    emoji: "🇮🇳",
    iso_code: "IN",
  },
  {
    name: "Indonesia",
    dial_code: "62",
    emoji: "🇮🇩",
    iso_code: "ID",
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    dial_code: "98",
    emoji: "🇮🇷",
    iso_code: "IR",
  },
  {
    name: "Iraq",
    dial_code: "964",
    emoji: "🇮🇷",
    iso_code: "IQ",
  },
  {
    name: "Ireland",
    dial_code: "353",
    emoji: "🇮🇪",
    iso_code: "IE",
  },
  {
    name: "Isle of Man",
    dial_code: "44",
    emoji: "🇮🇲",
    iso_code: "IM",
  },
  {
    name: "Israel",
    dial_code: "972",
    emoji: "🇮🇱",
    iso_code: "IL",
  },
  {
    name: "Italy",
    dial_code: "39",
    emoji: "🇮🇹",
    iso_code: "IT",
  },
  {
    name: "Jamaica",
    dial_code: "1876",
    emoji: "🇯🇲",
    iso_code: "JM",
  },
  {
    name: "Japan",
    dial_code: "81",
    emoji: "🇯🇵",
    iso_code: "JP",
  },
  {
    name: "Jersey",
    dial_code: "44",
    emoji: "🇯🇪",
    iso_code: "JE",
  },
  {
    name: "Jordan",
    dial_code: "962",
    emoji: "🇯🇴",
    iso_code: "JO",
  },
  {
    name: "Kazakhstan",
    dial_code: "77",
    emoji: "🇰🇿",
    iso_code: "KZ",
  },
  {
    name: "Kenya",
    dial_code: "254",
    emoji: "🇰🇪",
    iso_code: "KE",
  },
  {
    name: "Kiribati",
    dial_code: "686",
    emoji: "🇰🇮",
    iso_code: "KI",
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: "850",
    emoji: "🇰🇵",
    iso_code: "KP",
  },
  {
    name: "Korea, Republic of South Korea",
    dial_code: "82",
    emoji: "🇰🇷",
    iso_code: "KR",
  },
  {
    name: "Kuwait",
    dial_code: "965",
    emoji: "🇰🇼",
    iso_code: "KW",
  },
  {
    name: "Kyrgyzstan",
    dial_code: "996",
    emoji: "🇰🇬",
    iso_code: "KG",
  },
  {
    name: "Laos",
    dial_code: "856",
    emoji: "🇱🇦",
    iso_code: "LA",
  },
  {
    name: "Latvia",
    dial_code: "371",
    emoji: "🇱🇻",
    iso_code: "LV",
  },
  {
    name: "Lebanon",
    dial_code: "961",
    emoji: "🇱🇧",
    iso_code: "LB",
  },
  {
    name: "Lesotho",
    dial_code: "266",
    emoji: "🇱🇸",
    iso_code: "LS",
  },
  {
    name: "Liberia",
    dial_code: "231",
    emoji: "🇱🇷",
    iso_code: "LR",
  },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "218",
    emoji: "🇱🇾",
    iso_code: "LY",
  },
  {
    name: "Liechtenstein",
    dial_code: "423",
    emoji: "🇱🇮",
    iso_code: "LI",
  },
  {
    name: "Lithuania",
    dial_code: "370",
    emoji: "🇱🇹",
    iso_code: "LT",
  },
  {
    name: "Luxembourg",
    dial_code: "352",
    emoji: "🇱🇺",
    iso_code: "LU",
  },
  {
    name: "Macao",
    dial_code: "853",
    emoji: "🇲🇴",
    iso_code: "MO",
  },
  {
    name: "Macedonia",
    dial_code: "389",
    emoji: "🇲🇰",
    iso_code: "MK",
  },
  {
    name: "Madagascar",
    dial_code: "261",
    emoji: "🇲🇬",
    iso_code: "MG",
  },
  {
    name: "Malawi",
    dial_code: "265",
    emoji: "🇲🇼",
    iso_code: "MW",
  },
  {
    name: "Malaysia",
    dial_code: "60",
    emoji: "🇲🇾",
    iso_code: "MY",
  },
  {
    name: "Maldives",
    dial_code: "960",
    emoji: "🇲🇻",
    iso_code: "MV",
  },
  {
    name: "Mali",
    dial_code: "223",
    emoji: "🇲🇱",
    iso_code: "ML",
  },
  {
    name: "Malta",
    dial_code: "356",
    emoji: "🇲🇹",
    iso_code: "MT",
  },
  {
    name: "Marshall Islands",
    dial_code: "692",
    emoji: "🇲🇭",
    iso_code: "MH",
  },
  {
    name: "Martinique",
    dial_code: "596",
    emoji: "🇲🇶",
    iso_code: "MQ",
  },
  {
    name: "Mauritania",
    dial_code: "222",
    emoji: "🇲🇷",
    iso_code: "MR",
  },
  {
    name: "Mauritius",
    dial_code: "230",
    emoji: "🇲🇺",
    iso_code: "MU",
  },
  {
    name: "Mayotte",
    dial_code: "262",
    emoji: "🇾🇹",
    iso_code: "YT",
  },
  {
    name: "Mexico",
    dial_code: "52",
    emoji: "🇲🇽",
    iso_code: "MX",
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    dial_code: "691",
    emoji: "🇫🇲",
    iso_code: "FM",
  },
  {
    name: "Moldova",
    dial_code: "373",
    emoji: "🇲🇩",
    iso_code: "MD",
  },
  {
    name: "Monaco",
    dial_code: "377",
    emoji: "🇲🇨",
    iso_code: "MC",
  },
  {
    name: "Mongolia",
    dial_code: "976",
    emoji: "🇲🇳",
    iso_code: "MN",
  },
  {
    name: "Montenegro",
    dial_code: "382",
    emoji: "🇲🇪",
    iso_code: "ME",
  },
  {
    name: "Montserrat",
    dial_code: "1664",
    emoji: "🇲🇸",
    iso_code: "MS",
  },
  {
    name: "Morocco",
    dial_code: "212",
    emoji: "🇲🇦",
    iso_code: "MA",
  },
  {
    name: "Mozambique",
    dial_code: "258",
    emoji: "🇲🇿",
    iso_code: "MZ",
  },
  {
    name: "Myanmar",
    dial_code: "95",
    emoji: "🇲🇲",
    iso_code: "MM",
  },
  {
    name: "Namibia",
    emoji: "🇳🇦",
    dial_code: "264",
    iso_code: "NA",
  },
  {
    name: "Nauru",
    dial_code: "674",
    emoji: "🇳🇷",
    iso_code: "NR",
  },
  {
    name: "Nepal",
    dial_code: "977",
    emoji: "🇳🇵",
    iso_code: "NP",
  },
  {
    name: "Netherlands",
    dial_code: "31",
    emoji: "🇳🇱",
    iso_code: "NL",
  },
  {
    name: "Netherlands Antilles",
    dial_code: "599",
    emoji: "🇧🇶",
    iso_code: "AN",
  },
  {
    name: "New Caledonia",
    dial_code: "687",
    emoji: "🇳🇨",
    iso_code: "NC",
  },
  {
    name: "New Zealand",
    dial_code: "64",
    emoji: "🇳🇿",
    iso_code: "NZ",
  },
  {
    name: "Nicaragua",
    dial_code: "505",
    emoji: "🇳🇮",
    iso_code: "NI",
  },
  {
    name: "Niger",
    dial_code: "227",
    emoji: "🇳🇪",
    iso_code: "NE",
  },
  {
    name: "Nigeria",
    dial_code: "234",
    emoji: "🇳🇬",
    iso_code: "NG",
  },
  {
    name: "Niue",
    dial_code: "683",
    emoji: "🇳🇺",
    iso_code: "NU",
  },
  {
    name: "Norfolk Island",
    dial_code: "672",
    emoji: "🇳🇫",
    iso_code: "NF",
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "1670",
    emoji: "🇲🇵",
    iso_code: "MP",
  },
  {
    name: "Norway",
    dial_code: "47",
    emoji: "🇳🇴",
    iso_code: "NO",
  },
  {
    name: "Oman",
    dial_code: "968",
    emoji: "🇴🇲",
    iso_code: "OM",
  },
  {
    name: "Pakistan",
    dial_code: "92",
    emoji: "🇵🇰",
    iso_code: "PK",
  },
  {
    name: "Palau",
    dial_code: "680",
    emoji: "🇵🇼",
    iso_code: "PW",
  },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "970",
    emoji: "🇵🇸",
    iso_code: "PS",
  },
  {
    name: "Panama",
    dial_code: "507",
    emoji: "🇵🇦",
    iso_code: "PA",
  },
  {
    name: "Papua New Guinea",
    dial_code: "675",
    emoji: "🇵🇬",
    iso_code: "PG",
  },
  {
    name: "Paraguay",
    dial_code: "595",
    emoji: "🇵🇾",
    iso_code: "PY",
  },
  {
    name: "Peru",
    dial_code: "51",
    emoji: "🇵🇪",
    iso_code: "PE",
  },
  {
    name: "Philippines",
    dial_code: "63",
    emoji: "🇵🇭",
    iso_code: "PH",
  },
  {
    name: "Pitcairn",
    dial_code: "872",
    emoji: "🇵🇳",
    iso_code: "PN",
  },
  {
    name: "Poland",
    dial_code: "48",
    emoji: "🇵🇱",
    iso_code: "PL",
  },
  {
    name: "Portugal",
    dial_code: "351",
    emoji: "🇵🇹",
    iso_code: "PT",
  },
  {
    name: "Puerto Rico",
    dial_code: "1939",
    emoji: "🇵🇷",
    iso_code: "PR",
  },
  {
    name: "Qatar",
    dial_code: "974",
    emoji: "🇶🇦",
    iso_code: "QA",
  },
  {
    name: "Romania",
    dial_code: "40",
    emoji: "🇷🇴",
    iso_code: "RO",
  },
  {
    name: "Russia",
    dial_code: "7",
    emoji: "🇷🇺",
    iso_code: "RU",
  },
  {
    name: "Rwanda",
    dial_code: "250",
    emoji: "🇷🇼",
    iso_code: "RW",
  },
  {
    name: "Reunion",
    dial_code: "262",
    emoji: "🇷🇪",
    iso_code: "RE",
  },
  {
    name: "Saint Barthelemy",
    dial_code: "590",
    emoji: "🇧🇱",
    iso_code: "BL",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "290",
    emoji: "🇸🇭",
    iso_code: "SH",
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "1869",
    emoji: "🇰🇳",
    iso_code: "KN",
  },
  {
    name: "Saint Lucia",
    dial_code: "1758",
    emoji: "🇱🇨",
    iso_code: "LC",
  },
  {
    name: "Saint Martin",
    dial_code: "590",
    emoji: "🇲🇫",
    iso_code: "MF",
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "508",
    emoji: "🇵🇲",
    iso_code: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "1784",
    emoji: "🇻🇨",
    iso_code: "VC",
  },
  {
    name: "Samoa",
    dial_code: "685",
    emoji: "🇼🇸",
    iso_code: "WS",
  },
  {
    name: "San Marino",
    dial_code: "378",
    emoji: "🇸🇲",
    iso_code: "SM",
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "239",
    emoji: "🇸🇹",
    iso_code: "ST",
  },
  {
    name: "Saudi Arabia",
    dial_code: "966",
    emoji: "🇸🇦",
    iso_code: "SA",
  },
  {
    name: "Senegal",
    dial_code: "221",
    emoji: "🇸🇳",
    iso_code: "SN",
  },
  {
    name: "Serbia",
    dial_code: "381",
    emoji: "🇷🇸",
    iso_code: "RS",
  },
  {
    name: "Seychelles",
    dial_code: "248",
    emoji: "🇸🇨",
    iso_code: "SC",
  },
  {
    name: "Sierra Leone",
    dial_code: "232",
    emoji: "🇸🇱",
    iso_code: "SL",
  },
  {
    name: "Singapore",
    dial_code: "65",
    emoji: "🇸🇬",
    iso_code: "SG",
  },
  {
    name: "Slovakia",
    dial_code: "421",
    emoji: "🇸🇰",
    iso_code: "SK",
  },
  {
    name: "Slovenia",
    dial_code: "386",
    emoji: "🇸🇮",
    iso_code: "SI",
  },
  {
    name: "Solomon Islands",
    dial_code: "677",
    emoji: "🇸🇧",
    iso_code: "SB",
  },
  {
    name: "Somalia",
    dial_code: "252",
    emoji: "🇸🇴",
    iso_code: "SO",
  },
  {
    name: "South Africa",
    dial_code: "27",
    emoji: "🇿🇦",
    iso_code: "ZA",
  },
  {
    name: "South Sudan",
    dial_code: "211",
    emoji: "🇸🇸",
    iso_code: "SS",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "500",
    emoji: "🇬🇸",
    iso_code: "GS",
  },
  {
    name: "Spain",
    dial_code: "34",
    emoji: "🇪🇸",
    iso_code: "ES",
  },
  {
    name: "Sri Lanka",
    dial_code: "94",
    emoji: "🇱🇰",
    iso_code: "LK",
  },
  {
    name: "Sudan",
    dial_code: "249",
    emoji: "🇸🇩",
    iso_code: "SD",
  },
  {
    name: "Suriname",
    dial_code: "597",
    emoji: "🇸🇷",
    iso_code: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "47",
    emoji: "🇸🇯",
    iso_code: "SJ",
  },
  {
    name: "Swaziland",
    dial_code: "268",
    emoji: "🇸🇿",
    iso_code: "SZ",
  },
  {
    name: "Sweden",
    dial_code: "46",
    emoji: "🇸🇪",
    iso_code: "SE",
  },
  {
    name: "Switzerland",
    dial_code: "41",
    emoji: "🇨🇭",
    iso_code: "CH",
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "963",
    emoji: "🇸🇾",
    iso_code: "SY",
  },
  {
    name: "Taiwan",
    dial_code: "886",
    emoji: "🇹🇼",
    iso_code: "TW",
  },
  {
    name: "Tajikistan",
    dial_code: "992",
    emoji: "🇹🇯",
    iso_code: "TJ",
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    dial_code: "255",
    emoji: "🇹🇿",
    iso_code: "TZ",
  },
  {
    name: "Thailand",
    dial_code: "66",
    emoji: "🇹🇭",
    iso_code: "TH",
  },
  {
    name: "Timor-Leste",
    dial_code: "670",
    emoji: "🇹🇱",
    iso_code: "TL",
  },
  {
    name: "Togo",
    dial_code: "228",
    emoji: "🇹🇬",
    iso_code: "TG",
  },
  {
    name: "Tokelau",
    dial_code: "690",
    emoji: "🇹🇰",
    iso_code: "TK",
  },
  {
    name: "Tonga",
    dial_code: "676",
    emoji: "🇹🇴",
    iso_code: "TO",
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "1868",
    emoji: "🇹🇹",
    iso_code: "TT",
  },
  {
    name: "Tunisia",
    dial_code: "216",
    emoji: "🇹🇳",
    iso_code: "TN",
  },
  {
    name: "Turkey",
    dial_code: "90",
    emoji: "🇹🇷",
    iso_code: "TR",
  },
  {
    name: "Turkmenistan",
    dial_code: "993",
    emoji: "🇹🇲",
    iso_code: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    dial_code: "1649",
    emoji: "🇹🇨",
    iso_code: "TC",
  },
  {
    name: "Tuvalu",
    dial_code: "688",
    emoji: "🇹🇻",
    iso_code: "TV",
  },
  {
    name: "Uganda",
    dial_code: "256",
    emoji: "🇺🇬",
    iso_code: "UG",
  },
  {
    name: "Ukraine",
    dial_code: "380",
    emoji: "🇺🇦",
    iso_code: "UA",
  },
  {
    name: "United Arab Emirates",
    dial_code: "971",
    emoji: "🇦🇪",
    iso_code: "AE",
  },
  {
    name: "United Kingdom",
    dial_code: "44",
    emoji: "🇬🇧",
    iso_code: "GB",
  },
  {
    name: "United States",
    dial_code: "1",
    emoji: "🇺🇸",
    iso_code: "US",
  },
  {
    name: "Uruguay",
    dial_code: "598",
    emoji: "🇺🇾",
    iso_code: "UY",
  },
  {
    name: "Uzbekistan",
    dial_code: "998",
    emoji: "🇺🇿",
    iso_code: "UZ",
  },
  {
    name: "Vanuatu",
    dial_code: "678",
    emoji: "🇻🇺",
    iso_code: "VU",
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    dial_code: "58",
    emoji: "🇻🇪",
    iso_code: "VE",
  },
  {
    name: "Vietnam",
    dial_code: "84",
    emoji: "🇻🇳",
    iso_code: "VN",
  },
  {
    name: "Virgin Islands, British",
    dial_code: "1284",
    emoji: "🇻🇬",
    iso_code: "VG",
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "1340",
    emoji: "🇻🇮",
    iso_code: "VI",
  },
  {
    name: "Wallis and Futuna",
    dial_code: "681",
    emoji: "🇼🇫",
    iso_code: "WF",
  },
  {
    name: "Yemen",
    dial_code: "967",
    emoji: "🇾🇪",
    iso_code: "YE",
  },
  {
    name: "Zambia",
    dial_code: "260",
    emoji: "🇿🇲",
    iso_code: "ZM",
  },
  {
    name: "Zimbabwe",
    dial_code: "263",
    emoji: "🇿🇼",
    iso_code: "ZW",
  },
];

export const CountryCodeSelect = ({
  id,
  label,
  fullWidth = true,
  sx,
  ...props
}) => {
  return (
    <CustomSelect
      id={id}
      label={label}
      fullWidth={fullWidth}
      options={COUNTRIES.map((country) => ({
        value: country.dial_code,
        label: `${country.emoji} +${country.dial_code}`,
      }))}
      sx={sx}
      {...props}
    />
  );
};

CountryCodeSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  sx: PropTypes.object,
};
